import * as API from "./base";

export const show = (id) =>
  API.get("/recommendation_request/" + id + "/parameters");
